import {Loader} from "../../_snowpack/pkg/@googlemaps/js-api-loader.js";
import {GlasContainerMapManager} from "./GlasContainerMapManager.js";
import {GlasContainerGeocoder} from "./GlasContainerGeocoder.js";
import {GlasContainerReturnChannelForm} from "./GlasContainerReturnChannelForm.js";
import {GlasContainerUI} from "./Classes/GlasContainerUI.js";
export class GlasContainerSearchForm {
  constructor() {
    this.glasContainerSearch = document.querySelector(".glas-container-locations__search");
    this.ui = new GlasContainerUI(this.glasContainerSearch);
    this.locationUrl = this.glasContainerSearch.getAttribute("data-location-url");
    this.glasContainerSubmit = this.glasContainerSearch.querySelector(".glas-container-locations__form-submit");
    this.radiusSelect = this.glasContainerSearch.querySelector(".glas-container-locations__form-input--radius");
    this.glasContainerForm = this.glasContainerSearch.querySelector(".glas-container-locations__form");
    this.glasContainerGeoSubmit = this.glasContainerSearch.querySelector(".marker");
    this.submitContainer = this.glasContainerSearch.querySelector(".glas-container-locations__form-input-container--submit");
    this.radiusContainer = this.glasContainerSearch.querySelector(".glas-container-locations__form-input-container--radius");
    this.addressInput = this.glasContainerSearch.querySelector(".glas-container-locations__form-input--address");
    this.locationHitsSpan = this.glasContainerSearch.querySelector(".glas-container-locations__hits");
    this.mapContainer = this.glasContainerSearch.querySelector(".glas-container-locations__map-container");
    this.notFoundMessageElements = this.glasContainerSearch.querySelectorAll(".glas-container-locations__not-found");
    this.newContainerReport = this.glasContainerSearch.querySelector(".glas-container-reportNewContainer");
    this.loader = new Loader({
      apiKey: "AIzaSyCbu9J2QDRtYwUTRPuzdYUErVbb0jAk1j8",
      language: "de",
      libraries: ["geometry"]
    });
  }
  initListeners() {
    this.ui.addClickListener(this.glasContainerGeoSubmit, this.getUserPositionByGeolocation.bind(this));
    this.ui.addClickListener(this.glasContainerSubmit, this.getUserPositionByAddress.bind(this));
    this.ui.addSubmitListener(this.glasContainerForm, this.getUserPositionByAddress.bind(this));
    this.ui.addClickListener(this.newContainerReport, this.openReportNewContainer.bind(this));
  }
  initGlasContainerSearch() {
    this.glasContainerReturnChannelForm = new GlasContainerReturnChannelForm();
    this.initListeners();
  }
  openReportNewContainer() {
    const returnChannelFormElement = document.querySelector(".contact-form-glas-container-return-channel");
    this.ui.toggleElementVisibility(returnChannelFormElement, true);
    returnChannelFormElement.classList.add("padding-top--m", "padding-bottom--m");
    const newLocationCheckbox = returnChannelFormElement?.querySelector('input[id*="isNewLocation"]');
    if (newLocationCheckbox) {
      newLocationCheckbox.checked = true;
      newLocationCheckbox.dispatchEvent(new Event("change"));
    }
    const stickyHeaderHeight = document.querySelector(".header--sticky")?.clientHeight || 0;
    this.ui.scrollToElement(returnChannelFormElement, stickyHeaderHeight);
  }
  async getUserPositionByGeolocation() {
    this.ui.hideAndShowLoadingIndicator(true);
    if (!this.glasContainerGeocoder) {
      this.glasContainerGeocoder = new GlasContainerGeocoder();
    }
    try {
      const userPosition = await this.glasContainerGeocoder.getCurrentPosition();
      await this.initGlasContainerMap(userPosition);
    } catch (error) {
      console.error("error while fetching user position:", error);
      this.hideAndShowElements(false);
    } finally {
      this.ui.hideAndShowLoadingIndicator(false);
    }
  }
  getUserPositionByAddress(event) {
    event.preventDefault();
    const userLocationInput = this.addressInput.value.trim();
    if (!!userLocationInput) {
      this.ui.hideAndShowLoadingIndicator(true);
      this.initGlasContainerMap(userLocationInput).finally(() => this.ui.hideAndShowLoadingIndicator(false));
    } else {
      this.hideAndShowElements(false);
    }
  }
  async initGlasContainerMap(userLocationInput) {
    await this.loader.load();
    if (!this.glasContainerGeocoder) {
      this.glasContainerGeocoder = new GlasContainerGeocoder();
    }
    try {
      const {locations, geocodeResult} = await this.glasContainerGeocoder.fetchLocations(userLocationInput, this.locationUrl, String(this.radiusSelect.options[this.radiusSelect.options.length - 1].value));
      if (locations.length > 0) {
        if (!this.glasContainerMap) {
          this.glasContainerMap = new GlasContainerMapManager(this.mapContainer, this.radiusSelect, this.locationHitsSpan, this.glasContainerForm, this.glasContainerReturnChannelForm);
        }
        await this.glasContainerMap.initMap(locations, geocodeResult);
        this.hideAndShowElements(true);
      } else {
        this.hideAndShowElements(false);
      }
    } catch (error) {
      console.error("Error while initializing the map:", error);
      this.ui.showMessageElements(this.notFoundMessageElements, true);
    }
  }
  hideAndShowElements(locationsFound) {
    if (locationsFound) {
      this.ui.toggleElementVisibility(this.submitContainer, true);
      this.ui.toggleElementVisibility(this.radiusContainer, true);
      this.ui.toggleElementVisibility(this.mapContainer, true);
      this.ui.showMessageElements(this.notFoundMessageElements, false);
    } else {
      this.ui.toggleElementVisibility(this.radiusContainer, false);
      this.ui.toggleElementVisibility(this.mapContainer, false);
      this.ui.showMessageElements(this.notFoundMessageElements, true);
    }
  }
}
